<template>
  <div>
    <!-- pc -->
    <div class="door">
      <div class="left" v-loading="loading">
        <div class="searchTool fl">
          <div class="tool" v-show="showToll">
            <!-- 限制条件1 -->
            <div class="fl limit1">
              排序方式:
              <el-dropdown trigger="click" placement="bottom-start">
                <span class="el-dropdown-link">
                  <span v-if="queryInfo.isDate == false">按相关度</span>
                  <span v-else>按日期</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu popper-class="dropdown" slot="dropdown">
                  <el-dropdown-item
                    ><span
                      @click="limit1"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >按相关度排序</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="limit1"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >按日期排序</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <span
              :class="{ bottom_border: queryInfo.isDate == false }"
              @click="limit1()"
              >按相关度排序</span
            >
            /<span
              :class="{ bottom_border: queryInfo.isDate == true }"
              @click="limit1()"
              >按日期排序</span
            > -->
            </div>
            <!-- 限制条件2 -->
            <div class="fl limit2">
              检索范围:
              <el-dropdown trigger="click" placement="bottom-start">
                <span class="el-dropdown-link">
                  <span v-if="queryInfo.isTitle == false">按全文</span>
                  <span v-else-if="queryInfo.isTitle == true">按标题</span>
                  <span v-else>按文号</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu popper-class="dropdown" slot="dropdown">
                  <el-dropdown-item
                    ><span
                      @click="limit2"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >按全文检索</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="limit2bt"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >按标题检索</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="limit2wh"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >按文号检索</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>

              <!-- <span
              :class="{ bottom_border: queryInfo.isTitle == false }"
              @click="limit2()"
              >按全文检索</span
            >/<span
              :class="{ bottom_border: queryInfo.isTitle == true }"
              @click="limit2()"
              >按标题检索</span
            > -->
            </div>
            <!-- 限制条件3 -->
            <div class="fl limit3">
              时间范围:
              <el-dropdown trigger="click" placement="bottom-start">
                <span class="el-dropdown-link">
                  <span v-if="queryInfo.date == ''">时间不限</span>
                  <span v-else>{{
                    queryInfo.date[0] + "至" + queryInfo.date[1]
                  }}</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu popper-class="dropdown" slot="dropdown">
                  <el-dropdown-item
                    ><span
                      @click="timeUnlimit"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >时间不限</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="getLastWeek"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >最近一周</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="getLastMonth"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >最近一月</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="getLastYear"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >最近一年</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item>
                    自定义
                    <el-date-picker
                      v-model="queryInfo.date"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                      @change="zidingyi"
                    >
                    </el-date-picker
                  ></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 限制条件5 -->
            <div class="fl limit3">
              匹配度:
              <el-dropdown trigger="click" placement="bottom-start">
                <span class="el-dropdown-link">
                  <span v-if="queryInfo.isMohu == true">精准</span>
                  <span v-else>模糊</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu popper-class="dropdown" slot="dropdown">
                  <el-dropdown-item
                    ><span
                      @click="limit5"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >模糊</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item
                    ><span
                      @click="limit5"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >精准</span
                    ></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <!-- 限制条件4 -->
            <!-- <div class="limit4 fl">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                {{ queryInfo.fileType
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="附件类型">不限</el-dropdown-item>
                <el-dropdown-item command="word">word</el-dropdown-item>
                <el-dropdown-item command="ppt">ppt</el-dropdown-item>
                <el-dropdown-item command="pdf">pdf</el-dropdown-item>
                <el-dropdown-item command="excel">excel</el-dropdown-item>
                <el-dropdown-item command="zip">zip</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div> -->
            <!-- 高级检索 -->
            <div class="advanceSearch">
              <!-- <span class="sign">高级检索</span>
          <span class="btnAdvance" @click="btn_highSearch"> </span> -->

              <!-- 高级搜索下拉框 -->
              <el-drawer
                title="高级搜索"
                :with-header="false"
                :visible.sync="drawer"
                :direction="direction"
                size="60%"
                modal
              >
                <div class="title">
                  <div
                    class="tag fl"
                    :class="{ active: highChange }"
                    style="margin-right: 60px"
                  >
                    高级检索
                  </div>
                  <!-- <div
                class="tag fl"
                :class="{ active: !highChange }"
                @click="highChange = !highChange"
              >
                政策文件
              </div> -->

                  <div
                    class="mark fr"
                    @click="drawer = false"
                    style="font-size: 14px"
                  >
                    收起
                    <i
                      ><img
                        src="../../assets/img/normal_search/mark.png"
                        alt=""
                    /></i>
                  </div>
                </div>
                <div class="advanceBody" v-if="highChange">
                  <!-- 搜索结果部分 -->
                  <div class="searchResult">
                    <span class="Title fl" style="font-weight: bold"
                      >搜索结果:</span
                    >
                    <div class="allKey fl">
                      包含以下全部的关键词:
                      <input type="text" v-model="queryInfo.searchKey" maxlength="50" />
                    </div>
                    <!-- <div style="clear: both"></div> -->
                    <div class="totalKey fl">
                      包含以下的完整关键词:
                      <input type="text" v-model="queryInfo.totalKey" maxlength="50" />
                    </div>
                    <div style="clear: both"></div>

                    <div class="anyKey fl">
                      包含以下任意一个关键词:
                      <input type="text" v-model="queryInfo.anyKey" maxlength="50" />
                    </div>
                    <!-- <div style="clear: both"></div> -->

                    <div class="noKey fl">
                      不包含以下关键词:
                      <input
                        style="margin-left: 60px"
                        type="text"
                        v-model="queryInfo.noKey"
                        maxlength="50"
                      />
                    </div>
                    <div style="clear: both"></div>
                  </div>

                  <!-- 时间范围部分 -->
                  <div class="dateArea">
                    <span class="Title">时间范围:</span>
                    <el-radio-group
                      v-model="dateSelect"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="9">全部时间</el-radio>
                      <el-radio :label="1">最近一周</el-radio>
                      <el-radio :label="2">最近一月</el-radio>
                      <el-radio :label="3">最近一年</el-radio>
                      <el-radio :label="4">自定义</el-radio>
                    </el-radio-group>
                    <el-date-picker
                      v-model="queryInfo.date"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                      :readonly="readonly"
                      style="margin-left: 20px"
                    >
                    </el-date-picker>
                  </div>
                  <!-- <el-dropdown
                style="margin-left: 40px"
                class="highDate"
                trigger="click"
              >
                <span class="el-dropdown-link">
                  <span v-if="queryInfo.date == ''">时间不限</span>
                  <span v-else>{{
                    queryInfo.date[0] + "至" + queryInfo.date[1]
                  }}</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu popper-class="dropdown" slot="dropdown">
                  <el-dropdown-item
                    ><span
                      @click="timeUnlimit"
                      style="
                        display: inline-block;
                        width: 350px;
                        font-size: 14px;
                        margin-bottom: 5px;
                      "
                      >时间不限</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item>
                    <el-date-picker
                      v-model="queryInfo.date"
                      type="daterange"
                      align="right"
                      unlink-panels
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                    >
                    </el-date-picker
                  ></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->

                  <!-- 排序方式部分 -->
                  <div class="sortOrder">
                    <span class="Title"> 排序方式:</span>
                    <el-radio-group
                      v-model="queryInfo.isDate"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="false">按相关度排序</el-radio>
                      <el-radio :label="true">按时间排序</el-radio>
                    </el-radio-group>
                  </div>

                  <!-- 搜索位置部分 -->
                  <div class="searchPosition">
                    <span class="Title"> 搜索位置: </span>
                    <el-radio-group
                      v-model="queryInfo.isTitle"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="false">任何地方</el-radio>
                      <el-radio :label="true">仅标题</el-radio>
                    </el-radio-group>
                  </div>
                  <input
                    class="advanceSeachBtn"
                    type="submit"
                    value="搜索"
                    @click="highSearch(queryInfo.searchKey)"
                  />
                  <input
                    class="advanceSeachBtn"
                    type="submit"
                    value="重置"
                    @click="reset"
                    style="
                      margin-left: 30px;
                      background-color: rgb(228, 228, 228);
                      color: black;
                    "
                  />
                </div>
                <div class="clear"></div>
                <!-- 政策文件搜索 -->
                <div class="advanceBody" v-if="!highChange">
                  <div class="row" style="margin-top: 35px">
                    <span style="width: 60px">关键词</span>
                    <input
                      type="text"
                      style="margin-right: 80px"
                      v-model="queryInfo.searchKey"
                    />
                    <span style="margin-right: 80px">发文机构</span>
                    <input type="text" />
                  </div>
                  <div class="row">
                    <span style="width: 60px"> 发文字号</span>
                    <input
                      type="text"
                      placeholder="发文代字,如:呼政发"
                      style="width: 290px; margin-right: 40px"
                    />
                    <input
                      type="text"
                      placeholder="发文年份"
                      style="width: 290px; margin-right: 40px"
                    />
                    <input
                      type="text"
                      placeholder="具体文号"
                      style="width: 290px"
                    />
                    <span>号</span>
                  </div>
                  <div class="row">
                    <span style="width: 60px">日期</span>
                    <span style="margin-left: 15px">从</span>
                    <input
                      type="text"
                      placeholder="开始日期"
                      style="
                        width: 260px;
                        margin-left: 10px;
                        margin-right: 35px;
                      "
                    />
                    <span>至</span>
                    <input
                      type="text"
                      placeholder="结束日期"
                      style="width: 260px; margin-left: 3px"
                    />
                  </div>
                  <div class="row">
                    <span>搜索位置</span>
                    <el-radio-group
                      v-model="queryInfo.isDate"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="1">全部</el-radio>
                      <el-radio :label="2">标题</el-radio>
                      <el-radio :label="3">正文</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="row">
                    <span>结果排序</span>
                    <el-radio-group
                      v-model="queryInfo.isDate"
                      style="margin-left: 40px"
                    >
                      <el-radio :label="false">按相关度排序</el-radio>
                      <el-radio :label="true">按时间排序</el-radio>
                    </el-radio-group>
                  </div>

                  <input
                    class="advanceSeachBtn"
                    type="submit"
                    value="搜索"
                    @click="highSearch(queryInfo.searchKey)"
                  />
                  <input
                    class="advanceSeachBtn"
                    type="submit"
                    value="重置"
                    @click="reset"
                    style="
                      margin-left: 30px;
                      background-color: rgb(228, 228, 228);
                      color: black;
                    "
                  />
                </div>
              </el-drawer>
            </div>

            <!-- 总数 -->
            <div class="fr" style="margin-right: 0px">
              为您找到相关结果约<span class="total">{{ " " + total }}</span> 个
            </div>
          </div>
          <!-- <div class="isShow fr">
          <div class="show" v-show="!showToll" @click="showToll = !showToll">
            <i></i> 搜索工具
          </div>
          <div class="unShow" v-show="showToll" @click="showToll = !showToll">
            <i></i> 收起工具
          </div>
        </div> -->
        </div>
        <div class="clear"></div>
        <!-- 修正关键词 -->

        <div
          class="isAlways"
          style="
            font-size: 16px;
            margin-bottom: 40px;
            margin-left: 50px;
            font-weight: bold;
          "
          v-if="correctData != '' && correctData != undefined"
        >
          <i style=""></i>
          已显示 :"<span style="color: red">{{ correctData.trueWord }}</span
          >"的搜索结果。依然搜索 :
          <span
            style="color: #004a7c; cursor: pointer"
            @click="Always(correctData.errorWord)"
            >{{ correctData.errorWord }}</span
          >
        </div>
        <!-- 当total为0时显示 -->
        <div
          class="noResult"
          v-if="
            total == 0 &&
            isScence == false &&
            isLeader == false &&
            isCity == false
          "
          v-show="!loading"
        >
          <strong>很抱歉！未能搜到您想要的内容</strong>
          <br />
          <strong>建议您</strong>
          <br />
          <strong>1.看看输入的文字是否有错误</strong>
          <br />
          <strong>2.去掉可能不必要的词或条件</strong>
        </div>

        <!-- 最新相关消息 -->
        <v-special-newestmsg  v-if="newestmsgList != ''&&total != 0" :cKeyWord="queryInfo.searchKey"
          :cNewestmsgList="newestmsgList"></v-special-newestmsg>
        <!-- 身份证 -->
        <v-special-idcard
          v-if="isScence"
          v-show="queryInfo.currentPage == 1"
          :cScenceMap="scenceMap"
        ></v-special-idcard>

        <!-- 领导人 -->
        <v-special-leader
          v-if="isLeader"
          v-show="queryInfo.currentPage == 1"
          :cLeaderInfo="leaderInfo"
        ></v-special-leader>

        <!-- 城市 -->
        <v-special-city
          v-if="isCity"
          v-show="queryInfo.currentPage == 1"
          :cCityScence="CityScence"
        >
        </v-special-city>

        <ul style="padding: 0:margin:0">
          <li v-for="(item, index) in dataList" :key="index">
            <!-- 政策表格 -->
            <v-table-zc
              v-if="item.index === 'search_hy_zc'"
              :cNormalData="item"
            >
            </v-table-zc>
            <!-- 办事表格 -->
            <v-table-work
              v-if="item.index === 'search_dev_item'"
              :cWorkData="item"
            ></v-table-work>
            <!-- 要闻图文信息 -->
            <v-TablePicYw
              v-if="item.index === 'search_hy_news'"
              :cPicData="item"
            ></v-TablePicYw>
            <!-- 公报全真版 -->
            <!-- <v-TablePicYw
              v-if="item.index == 'search_hy_gk' && item.dockind == 58"
              :cNormalData="item"
            >
            </v-TablePicYw> -->
            <!-- 互动图文信息 -->
            <v-TablePicHd
              v-if="item.index === 'search_hy_hd'"
              :cPicData="item"
            ></v-TablePicHd>
            <!-- 走进内蒙古图文信息 -->
            <v-TablePicZjnmg
              v-if="item.index === 'search_hy_nmg'"
              :cPicData="item"
            ></v-TablePicZjnmg>
            <!-- 公开图文信息 -->
            <v-TablePicGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 1"
              :cPicData="item"
            ></v-TablePicGk>
            <v-TablePicGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 4"
              :cPicData="item"
            ></v-TablePicGk>
            <!-- 公开表格信息 -->
            <v-TableGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 2"
              :cNormalData="item"
            >
            </v-TableGk>
            <!-- 公报表格信息 -->
            <v-TableGb
              v-if="item.index == 'search_hy_gk' && item.dockind == 3"
              :cNormalData="item"
            >
            </v-TableGb>
            
            <!-- 微信图文信息 -->
            <v-table-wechat
              v-if="item.index === 'search_dev_weixin'"
              :cDataListL="item"
            ></v-table-wechat>
            <!-- 文件类型图文信息 -->
            <v-TablePicFile
              v-if="item.index === 'search_hy_dix'"
              :cPicData="item"
            ></v-TablePicFile>
          </li>
        </ul>

        <!-- 分页 -->
        <!-- 当total为0时不显示 -->
        <el-pagination
          v-if="total != 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <div class="right">
        <!-- 智能推荐 -->
        <v-silder-recommend
          v-if="total != 0 && recommendList != ''"
          :cRecommendList="recommendList"
          :cKeyWord="queryInfo.searchKey"
          :cRecommendWords="recommendWords"
          @func="getSearchKey"
        ></v-silder-recommend>
        <!-- 统计信息 -->
        <!-- <v-silder-tjxx></v-silder-tjxx> -->
        <!-- 相关领导 -->
        <v-silder-leaders
          @func="getSearchKey"
          v-show="otherleaders != ''"
          :cOtherLeaders="otherleaders"
        ></v-silder-leaders>
        <!-- 热搜排行 -->
        <!-- <v-silder-rank :cList="rank" @func="getSearchKey"></v-silder-rank> -->
        <v-silder-hot v-if="rank != ''" :cList="rank" @func="getSearchKey">
        </v-silder-hot>
        <!-- 相关系统 -->
        <v-silder-system
          v-if="SystemScenceList_sys != ''"
          :cSystemScenceList_sys="SystemScenceList_sys"
        ></v-silder-system>
        <!-- 相关机构 -->
        <v-silder-department
          v-if="SystemScenceList_org != ''"
          :cSystemScenceList_org="SystemScenceList_org"
        ></v-silder-department>
        <v-silder-satisfiaed
          :cKeyWord="queryInfo.searchKey"
        ></v-silder-satisfiaed>
        <wordcloud></wordcloud>

        <v-silder-history @func="getSearchKey"></v-silder-history>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="mobile">
      <div class="mobile_main" v-loading="loading">
        <!-- 修正关键词 -->
        <div
          class="isAlways"
          v-if="correctData != '' && correctData != undefined"
        >
          <i style=""></i>
          已显示 :"<span style="color: red">{{ correctData.trueWord }}</span
          >"的搜索结果。依然搜索 :
          <span
            style="color: #004a7c; cursor: pointer"
            @click="Always(correctData.errorWord)"
            >{{ correctData.errorWord }}</span
          >
        </div>
        <!-- 当total为0时显示 -->
        <div
          class="noResult"
          v-if="
            total == 0 &&
            isScence == false &&
            isLeader == false &&
            isCity == false
          "
          v-show="!loading"
        >
          <strong>很抱歉！未能搜到您想要的内容</strong>
          <br />
          <strong>建议您</strong>
          <br />
          <strong>1.看看输入的文字是否有错误</strong>
          <br />
          <strong>2.去掉可能不必要的词或条件</strong>
        </div>
        
        <!-- 身份证 -->
        <v-special-idcard
          v-if="isScence"
          v-show="queryInfo.currentPage == 1"
          :cScenceMap="scenceMap"
        ></v-special-idcard>

        <!-- 领导人 -->
        <v-special-leader
          v-if="isLeader"
          v-show="queryInfo.currentPage == 1"
          :cLeaderInfo="leaderInfo"
        ></v-special-leader>

        <!-- 城市 -->
        <v-special-city
          v-if="isCity"
          v-show="queryInfo.currentPage == 1"
          :cCityScence="CityScence"
        >
        </v-special-city>
        <ul style="padding: 0:margin:0">
          <li v-for="(item, index) in dataList" :key="index">
            <!-- {{ item.index }} -->
            <!-- 政策表格 -->
            <v-table-zc
              v-if="item.index === 'search_hy_zc'"
              :cNormalData="item"
            >
            </v-table-zc>
            <!-- 办事表格 -->
            <v-table-work
              v-if="item.index === 'search_dev_item'"
              :cWorkData="item"
            ></v-table-work>
            <!-- 要闻图文信息 -->
            <v-TablePicYw
              v-if="item.index === 'search_hy_news'"
              :cPicData="item"
            ></v-TablePicYw>
            <!-- 互动图文信息 -->
            <v-TablePicHd
              v-if="item.index === 'search_hy_hd'"
              :cPicData="item"
            ></v-TablePicHd>
            <!-- 走进内蒙古图文信息 -->
            <v-TablePicZjnmg
              v-if="item.index === 'search_hy_nmg'"
              :cPicData="item"
            ></v-TablePicZjnmg>
            <!-- 公开图文信息 -->
            <v-TablePicGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 1"
              :cPicData="item"
            ></v-TablePicGk>
            <v-TablePicGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 4"
              :cPicData="item"
            ></v-TablePicGk>
            <!-- 公开表格信息 -->
            <v-TableGk
              v-if="item.index === 'search_hy_gk' && item.dockind == 2"
              :cNormalData="item"
            >
            </v-TableGk>
            <!-- 公报表格信息 -->

            <v-TableGb
              v-if="item.index == 'search_hy_gk' && item.dockind == 3"
              :cNormalData="item"
            >
            </v-TableGb>
          </li>
        </ul>

        <!-- 分页 -->
        <el-pagination
          v-if="total != 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currentPage"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="queryInfo.pageSize"
          layout=" prev, pager, next"
          :total="total"
          :small="true"
          prev-text="上一页"
          next-text="下一页"
          :background="true"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// 最新相关消息
import vSpecialNewestmsg from '../special/special_newestmsg.vue'
import vSpecialCity from "../special/special_city";
import vSpecialIdcard from "../special/special_idcard";
import vSpecialLeader from "../special/special_leader";
import vSilderTjxx from "../sider/sider_tjxx";
import vSilderNews from "../sider/sider_news";
import vSilderLeaders from "../sider/sider_leaders";
import vSilderDepartment from "../sider/sider_department";
import vSilderSystem from "../sider/sider_system";
import vSilderRecommend from "../sider/sider_recommend";
import vSilderHot from "../sider/sider_hot";
import vSilderHistory from "../sider/sider_history";
import vSilderSatisfiaed from "../sider/sider_satisfiaed";

import vTableZc from "../table/table_zc";
import vTableWork from "../table/table_work";
import vTablePicYw from "../table/table_pic_yw";
import vTablePicHd from "../table/table_pic_hd";
import vTablePicZjnmg from "../table/table_pic_zjnmg";
import vTablePicGk from "../table/table_pic_gk";
import vTablePicFile from "../table/table_pic_file";
import vTableGk from "../table/table_gk";
import vTableGb from "../table/table_gb";
import wordcloud from "../sider/silder_hotWords";
import vTableWechat from "../table/table_wechat";
export default {
  name: "App",
  components: {
    vSpecialNewestmsg,
    vSpecialCity,
    vSpecialIdcard,
    vSpecialLeader,
    vSilderTjxx,
    vSilderNews,
    vSilderLeaders,
    vSilderDepartment,
    vSilderSystem,
    vSilderRecommend,
    vTableZc,
    vTableWork,
    vTablePicYw,
    wordcloud,
    vSilderHot,
    vTablePicHd,
    vTablePicZjnmg,
    vTableGk,
    vTableGb,
    vTablePicGk,
    vTablePicFile,
    vSilderHistory,
    vSilderSatisfiaed,
    vTableWechat
  },
  props: {
    fSort: "",
    fPosition: "",
    fDate: "",
    cSiteID: "",
  },
  data() {
    return {
      // 加载中
      loading: false,
      // 高级检索日期选项
      dateSelect: 9,
      readonly: true,
      // 分类id
      searchTag: "all",
      queryInfo: {
        // 搜索关键字
        searchKey: " ",
        // 包含以下全部的关键字
        allKey: "",
        // 包含以下的完整关键字
        totalKey: "",
        // 包含以下任意一个关键字
        anyKey: "",
        // 不包含以下关键字
        noKey: "",
        // 是否按日期排序
        isDate: false,
        sort: "",
        // 是否按标题检索
        isTitle: false,
        position: 0,
        // 是否模糊查询
        isMohu:true,
        // 匹配度
        isAccurate:1,
        // 日期
        date: [],
        //起始日期
        startDate: "",
        // 结束日期
        endDate: "",
        // 附件类型
        fileType: "附件类型",
        //附件类型搜索用
        Ftype: "",
        // 当前页码
        currentPage: 1,
        // 页面大小
        pageSize: 10,
      },
      // 控制高级搜索中日期单选部分
      radio: "",
      // 控制其它日期是否为只读
      readonly: true,
      // 控制搜索工具显示与否
      showToll: true,
      // 搜索部分数据
      // 控制高级搜索显示与否
      drawer: false,
      // 控制高级搜索区域显示方式
      direction: "ttb",
      // 相关结果数
      total: 0,

      // 时间选项
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 366);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      highChange: true,

      // 获取到的普通data
      dataList: [],
      // 获取最新相关消息
      newestmsgList: [],
      // 是否是领导人
      isLeader: false,
      // 领导人信息
      leaderInfo: {},
      // 其它领导人信息
      otherleaders: [],
      // 是否是场景化
      isScence: false,
      // 场景化信息
      scenceMap: {},
      // 搜索排行
      rank: [],
      // 城市场景化
      isCity: false,
      // 城市数据
      CityScence: {},
      isSystemScence: false,
      // 相关系统
      SystemScenceList_sys: [],
      // 相关机构
      SystemScenceList_org: [],
      // 获取智能推荐
      recommendList: [],
      // 获取智能推荐相关检索词
      recommendWords: [],
      // 是否订正关键词
      isAlways: 0,
      // 获取修正过后的关键词
      correctData: {},
    };
  },
  watch: {
    total: {
      handler() {
        this.postTotal();
      },
    },
    fSort: {
      handler() {
        if (this.fSort == 1) {
          this.queryInfo.sort = "";
          this.getDataList();
        }
        if (this.fSort == 2) {
          this.queryInfo.sort = "time";
          this.getDataList();
        }
      },
    },
    fPosition: {
      handler() {
        this.queryInfo.position = this.fPosition;
        this.getDataList();
      },
    },
    fDate: {
      handler() {
        this.dateSelect = this.fDate;
      },
    },
    "queryInfo.isDate": {
      handler() {
        if (this.queryInfo.isDate === false) {
          this.queryInfo.sort = "";
        }
        if (this.queryInfo.isDate === true) {
          this.queryInfo.sort = "time";
        }
        this.getDataList();
      },
    },
    "queryInfo.isTitle": {
      handler() {
        if (this.queryInfo.isTitle === false) {
          this.queryInfo.position = 0;
        }
        if (this.queryInfo.isTitle === true) {
          this.queryInfo.position = 1;
        }
        this.getDataList();
      },
    },
    "queryInfo.isMohu": {
      handler() {
        if (this.queryInfo.isMohu === true) {
          this.queryInfo.isAccurate = 1;
        }
        if (this.queryInfo.isMohu === false) {
          this.queryInfo.isAccurate = 0;
        }
        this.getDataList();
      },
    },
    "queryInfo.date": {
      handler() {
        this.getDataList();
      },
    },
    dateSelect: {
      handler() {
        if (this.dateSelect == 1) {
          this.readonly = true;
          this.getLastWeek();
          // var date = new Date();
          // var today = this.timeFormat(date); //当前日期
          // var week = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
          // var weekDate = this.timeFormat(week); //最近一周第一天
          // this.queryInfo.date = [weekDate, today];
        }
        if (this.dateSelect == 2) {
          this.readonly = true;
          this.getLastMonth();
        }
        if (this.dateSelect == 3) {
          this.readonly = true;
          this.getLastYear();
        }
        if (this.dateSelect == 4) {
          this.readonly = false;
          // this.queryInfo.date = [];
        }
        if (this.dateSelect == 9) {
          this.readonly = true;

          this.timeUnlimit();
        }
      },
    },
    $route(to, from) {
      this.queryInfo.searchKey = this.$route.query.keywords;
      this.$emit("rhighSearch", this.queryInfo.searchKey);
      this.getDataList();
    },
  },
  computed: {
    // 从vuex中获取search的值
    StoreSearch() {
      return this.$store.state.search;
    },
    // 提交给接口的数据
    parameters() {
      return {
        // 站点id(必传)
        siteId: this.cSiteID,
        // 分类名称(必传)
        searchTag: this.searchTag,
        // 检索词(必传)
        // allKeywords: encodeURIComponent(this.queryInfo.searchKey),
        allKeywords: this.queryInfo.searchKey,
        // 包含精确的关键词，多个关键词用空格分割
        // fullKeywords: this.queryInfo.totalKey.split(" "),
        fullKeywords: this.queryInfo.totalKey,
        // 包含任意的关键词，多个关键词用空格分割
        // orKeywords: this.queryInfo.anyKey.split(" "),
        orKeywords: this.queryInfo.anyKey,
        // 不包含的关键词，多个关键词用空格分割
        // notKeywords: this.queryInfo.noKey.split(" "),
        notKeywords: this.queryInfo.noKey,
        // 排序，传【time】则按时间排序，否则按相关度排序
        sort: this.queryInfo.sort,
        // 检索位置【0全文 1标题】
        position: this.queryInfo.position,
        // 时间【week,month,year】
        // timeTag: "",
        // 开始时间
        startTime: this.queryInfo.date[0],
        // 结束时间
        endTime: this.queryInfo.date[1],
        // 政策发布机构
        organization: "",
        // 页码,必传
        pageNum: this.queryInfo.currentPage,
        // 页面大小，必传
        pageSize: this.queryInfo.pageSize,
        // 政策发布年份
        zcYear: "",
        // 是否修订关键词
        isAlways: this.isAlways,
        // 附件类型
        fileTag: this.queryInfo.Ftype,
      };
    },
  },
  methods: {
    // openFullScreen2() {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "Loading",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    //   setTimeout(() => {
    //     loading.close();
    //   }, 2000);
    // },
    // 获取数据
    async getDataList() {
      // 记录搜索记录
      this.$store.commit("getSearchHistory", this.queryInfo.searchKey);
      this.loading = true;
      let params = this.$qs.stringify({
          siteId:this.cSiteID,
            searchTag: this.searchTag,
            allKeywords: this.queryInfo.searchKey,
            fullKeywords: this.queryInfo.totalKey,
            orKeywords: this.queryInfo.anyKey,
            notKeywords: this.queryInfo.noKey,
            sort: this.queryInfo.sort,
            position: this.queryInfo.position,
            startTime: this.queryInfo.date[0],
            endTime: this.queryInfo.date[1],
            organization: "",
            pageNum: this.queryInfo.currentPage,
            pageSize: this.queryInfo.pageSize,
            zcYear: "",
            isAlways: this.isAlways,
            fileTag: this.queryInfo.Ftype,
            // 匹配度
            isAccurate:this.queryInfo.isAccurate

      });
      // let params1=this.$qs.parse(params)
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/searchAll.do?"+params,
        // {
          // params: params1,
        //   params: {
        //     siteId:this.cSiteID,
        //     searchTag: this.searchTag,
        //     allKeywords: this.$qs.stringify(this.queryInfo.searchKey),
        //     fullKeywords: this.queryInfo.totalKey,
        //     orKeywords: this.queryInfo.anyKey,
        //     notKeywords: this.queryInfo.noKey,
        //     sort: this.queryInfo.sort,
        //     position: this.queryInfo.position,
        //     startTime: this.queryInfo.date[0],
        //     endTime: this.queryInfo.date[1],
        //     organization: "",
        //     pageNum: this.queryInfo.currentPage,
        //     pageSize: this.queryInfo.pageSize,
        //     zcYear: "",
        //     isAlways: this.isAlways,
        //     fileTag: this.queryInfo.Ftype
        //   },
        // }
      );
      // console.log(params);
      // console.log(params1);
      if (res.state != 200) {
        // this.$message.error(res.message);
        this.correctData = "";
      } else {
        // this.$message.success("成功获取数据");

        // 获取普通数据
        this.dataList = res.data.data;
        // 是否是领导人
        this.isLeader = false;
        // 是否是场景化
        this.isScence = false;
        // 是否是城市
        this.isCity = false;
        // 是否是相关系统机构
        this.isSystemScence = false;
        // 是否是领导人
        if (res.data.isLeader === true) {
          // 是领导人
          this.isLeader = res.data.isLeader;
          // 领导人信息
          this.leaderInfo = res.data.leaderInfo;
          // 其它领导人信息
          this.otherleaders = res.data.otherleaders;
          // console.log(this.isLeader);
        }
        // 是否是场景化
        if (res.data.isScence === true) {
          // 是场景化
          this.isScence = res.data.isScence;

          // 获取场景化数据
          this.scenceMap = res.data.scenceMap;
          // console.log(this.scenceMap);
        }
        // 是城市
        if (res.data.isCityScence === true) {
          // 是否是城市
          this.isCity = res.data.isCityScence;
          // 获取城市数据
          this.CityScence = res.data.CityScence;
        }
        // 是否是相关机构系统
        if (res.data.isSystemScence === true) {
          this.SystemScenceList_sys = res.data.SystemScenceList_sys;
          this.SystemScenceList_org = res.data.SystemScenceList_org;
        }
        // 当前页
        this.queryInfo.currentPage = res.data.pageNum;
        // 每页数据量
        this.queryInfo.pageSize = res.data.pageSize;
        // 总页数
        this.total = res.data.total;
        this.$emit("fGetTotal", this.total);
        // console.log("获取到的数据");
        // 修正关键词
        if (res.data.isCorrect == true) {
          this.isAlways = 0;
          this.correctData = res.data.correctData;
          // console.log(this.correctData);
        } else {
          this.isAlways = 1;
          this.correctData = res.data.correctData;
        }
      }
      this.loading = false;
    },

    // 获取搜索热点
    async getRank() {
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/gethotSearch.do",
        {
          params: { siteId: 39 },
        }
      );
      if (res.code == 200) {
        this.rank = res.result;
      }
      // console.log(this.rank);
    },
    // 获取智能推荐
    async getRecommend() {
      let params = this.$qs.stringify({
            allKeywords: this.queryInfo.searchKey,
            pageNum: 1,
            siteId: 39,
            searchTag: this.searchTag,
            pageSize: 50,

      });
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/searchSuggest.do?"+params,
        // {
        //   params: {
        //     allKeywords: this.queryInfo.searchKey,
        //     pageNum: 1,
        //     siteId: 39,
        //     searchTag: this.searchTag,
        //     pageSize: 50,
        //   }
        // }
      );
      if (res.state == 200) {
        this.recommendList = res.data.suggest;
      }
    },
    // 获取最新相关消息
    async getNewestmsg() {
      let params = this.$qs.stringify({
            keywords: this.queryInfo.searchKey,
            // pageNum: 1,
            siteId: 39,
            searchTag: this.searchTag,
            pageSize: 10,

      });
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/findMessage?"+params,
        // {
        //   params: {
        //     allKeywords: this.queryInfo.searchKey,
        //     pageNum: 1,
        //     siteId: 39,
        //     searchTag: this.searchTag,
        //     pageSize: 50,
        //   }
        // }
      );
      if (res.state == 200) {
        this.newestmsgList = res.data;
      }
    },
    // 获取智能推荐关联词
    async getRecommendWords() {
      let params=this.$qs.stringify({
        word: this.queryInfo.searchKey,
      })
      const { data: res } = await this.$http.get(
        "/nmsearch/trssearch/searchRelationKeyWord.do?"+params,
        // {
        //   params: {
        //     word: this.queryInfo.searchKey,
        //   },
        // }
      );
      if (res.code == 0) {
        this.recommendWords = res.words;
      }
    },

    // 点击其它领导人
    searchOtherLeader(leader) {
      this.searchKey = leader;
      this.getDataList();
    },

    // 是否按日期排序
    limit1() {
      this.queryInfo.isDate = !this.queryInfo.isDate;
      if (this.queryInfo.isDate === false) {
        this.queryInfo.sort = "";
      }
      if (this.queryInfo.isDate === true) {
        this.queryInfo.sort = "time";
      }
    },
    // 匹配度排序
    limit5() {
      this.queryInfo.isMohu = !this.queryInfo.isMohu;
      if (this.queryInfo.isMohu === true) {
        this.queryInfo.isAccurate = 1;
      }
      if (this.queryInfo.isMohu === false) {
        this.queryInfo.isAccurate = 0;
      }
    },

    // 是否按标题检索
    limit2() {
      this.queryInfo.isTitle = false;
      this.queryInfo.position = 0;
    },
    limit2bt() {
      this.queryInfo.isTitle = true;
      this.queryInfo.position = 1;
    },
    limit2wh() {
      this.queryInfo.isTitle = '文号';
      this.queryInfo.position = 2;
    },

    // 时间不限选项
    timeUnlimit() {
      this.queryInfo.date = [];
      this.dateSelect = 9;
    },
    //日期格式化，返回值形式为yy-mm-dd
    timeFormat(date) {
      if (!date || typeof date === "string") {
        this.error("参数异常，请检查...");
      }
      var y = date.getFullYear(); //年
      var m = date.getMonth() + 1; //月
      // 转化为两位数
      if (m < 10) {
        m = (Array(2).join(0) + m).slice(-2);
      }
      var d = date.getDate(); //日
      // 转化为两位数
      if (d < 10) {
        d = (Array(2).join(0) + d).slice(-2);
      }
      return y + "-" + m + "-" + d;
    },
    // 获取最近一周
    getLastWeek() {
      var date = new Date();
      var today = this.timeFormat(date); //当前日期
      var week = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
      var weekDate = this.timeFormat(week); //最近一周第一天
      // this.queryInfo.date[0] = weekDate;
      // this.queryInfo.date[1] = today;
      this.queryInfo.date = [weekDate, today];
      this.dateSelect = 1;
      this.getDataList();
    },
    // 获取最近一月
    getLastMonth() {
      var date = new Date();
      var today = this.timeFormat(date); //当前日期
      var month = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
      var monthDate = this.timeFormat(month); //最近一月第一天
      // this.queryInfo.date[0] = monthDate;
      // this.queryInfo.date[1] = today;
      this.queryInfo.date = [monthDate, today];
      this.dateSelect = 2;
      this.getDataList();
    },
    // 获取最近一年
    getLastYear() {
      var date = new Date();
      var today = this.timeFormat(date); //当前日期
      var year = new Date(date.getTime() - 3600 * 1000 * 24 * 365);
      var yearDate = this.timeFormat(year); //最近一年第一天
      // this.queryInfo.date[0] = yearDate;
      // this.queryInfo.date[1] = today;
      this.queryInfo.date = [yearDate, today];
      this.dateSelect = 3;
      this.getDataList();
    },
    // 父组件点击高级搜索
    btn_highSearch() {
      this.drawer = true;
      this.highChange = true;
    },
    btn_policySearch() {
      this.drawer = true;
      this.highChange = false;
    },
    // 点击高级搜索
    highSearch(searchKey) {
      if(searchKey){
        searchKey=searchKey.replace(/\s+/g,'');
      }
      if(this.queryInfo.totalKey){
        this.queryInfo.totalKey=this.queryInfo.totalKey.replace(/\s+/g,'');
      }
      if(this.queryInfo.anyKey){
        this.queryInfo.anyKey=this.queryInfo.anyKey.replace(/\s+/g,'');
      }
      if((searchKey == ""|| searchKey == undefined)&&(this.queryInfo.totalKey == ""|| this.queryInfo.totalKey == undefined)&&(this.queryInfo.anyKey == ""||this.queryInfo.anyKey== undefined)){
        this.$confirm("请至少输入一个包含关键词", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: "true",
        });
      }else{
        this.$emit("rhighSearch", searchKey);
        this.getDataList();
        this.drawer = false;
      }



      // if (searchKey == "" || searchKey == undefined) {
      //   this.$confirm("搜索内容不能为空", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //     center: "true",
      //   }); //用catch来捕获错误消息
      // } else {
        // this.$emit("rhighSearch", searchKey);
        // this.getDataList();
        // this.drawer = false;
      // }
    },

    // 分页
    // 监听当前页面显示数量改变
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getDataList();
    },

    // 监听当前页码
    handleCurrentChange(newPage) {
      this.queryInfo.currentPage = newPage;
      this.getDataList();
    },

    // 将本页面的搜索分类传向stroe
    // postSerachTag() {
    //   this.$store.commit("getSearchTag", this.searchTag);
    // },

    // 获取点击的侧边其他领导传来的领导名字
    //获取点击的热点
    getSearchKey(item) {
      this.$emit("rfunc", item);
    },

    // 向父组件传total
    postTotal() {
      this.$emit("fGetTotal", this.total);
    },

    // 选择附件类型
    handleCommand(command) {
      if (command == "附件类型") {
        this.searchTag = "all";
        this.queryInfo.Ftype = "";
        this.queryInfo.fileType = "附件类型";
      } else {
        this.searchTag = "file";
        this.queryInfo.Ftype = command;
        this.queryInfo.fileType = command;
      }
      this.getDataList();
    },
    // 点击高级检索中的重置按钮
    reset() {
      this.radio = 9;
      this.queryInfo.searchKey = "";
      this.queryInfo.totalKey = "";
      this.queryInfo.anyKey = "";
      this.queryInfo.noKey = "";
      this.queryInfo.date = "";
      this.queryInfo.isDate = false;
      this.queryInfo.sort = "time";
      this.queryInfo.isTitle = false;
      this.queryInfo.position = 0;
      // console.log(this.queryInfo.searhKey);
    },
    // 当搜索内容为空时提示
    isBlank() {
      if (
        this.queryInfo.searchKey == "" ||
        this.queryInfo.searchKey == " " ||
        this.queryInfo.searchKey == undefined
      ) {
        this.$confirm("搜索内容不能为空", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }); //用catch来捕获错误消息
      }
    },
    zidingyi() {
      this.dateSelect = 4;
    },
    Always(val) {
      this.isAlways = 1;
      this.queryInfo.searchKey = val;
      this.getDataList();
    },
  },
  created() {
    this.$emit("rIsActice", "门户网站");

    // 将搜索分类传向stroe
    // this.postSerachTag();
    // 将从vuex中获取到的search的值赋值给本页面的searchKey

    this.queryInfo.searchKey = this.StoreSearch;
    // this.isBlank();

    // 从url中取关键字
    if (this.queryInfo.searchKey == "") {
      this.queryInfo.searchKey = this.$route.query.keywords;
      this.$emit("rhighSearch", this.$route.query.keywords);
    }

    // console.log(this.queryInfo.searchKey);
    // 获取数据
    this.getDataList();
    // 获取热搜排行
    this.getRank();
    // 获取智能推荐
    this.getRecommend();
    this.getRecommendWords();
    window.addEventListener("click", this.inputFocus);
    // 获取最新相关消息
    this.getNewestmsg()
  },
  mounted() {
    // this.isBlank();
  },
};
</script>

<style lang='less' scoped>
ul {
  padding: 0;
  margin: 0;
}
@media screen and (min-width: 751px) {
  /deep/ .mobile {
    display: none;
  }
  .door {
    width: 1280px;
    margin: 0 auto;
    /deep/.el-loading-mask {
      background-color: none;
    }

    .searchTool {
      width: 830px;
      height: 25px;
      // margin-top: 40px;
      margin-bottom: 25px;
      /deep/.el-select {
        width: 114px;
      }
      span {
        cursor: pointer;
      }
      .total {
        color: rgb(255, 0, 0);
        font-size: 14px;
        font-weight: bold;
      }
      .limit1 {
        // color: rgb(1, 82, 147);
        // margin-left: 50px;
        /deep/.el-dropdown {
          border: 1px solid rgb(210, 210, 210);
          border-radius: 15px;
          padding-left: 5px;
          padding-right: 5px;
          line-height: 25px;
          span {
            color: #999999;
          }
        }
      }
      .limit2 {
        // color: rgb(1, 82, 147);
        margin-left: 10px;
        /deep/.el-dropdown {
          border: 1px solid rgb(210, 210, 210);
          border-radius: 15px;
          padding-left: 5px;
          padding-right: 5px;
          line-height: 25px;
          span {
            color: #999999;
          }
        }
      }
      .limit3 {
        // color: rgb(1, 82, 147);
        margin-left: 10px;
        /deep/.el-dropdown {
          border: 1px solid rgb(210, 210, 210);
          border-radius: 15px;
          padding-left: 5px;
          padding-right: 5px;
          line-height: 25px;
          span {
            color: #999999;
          }
        }
        li {
          span {
            display: inline-block;
            width: 350px;
            color: red;
          }
        }
      }
      .limit4 {
        color: rgb(1, 82, 147);
        margin-left: 30px;
      }
      .el-dropdown-link {
        cursor: pointer;
        // color: rgb(1, 82, 147);
        color: black;
      }
      /deep/.el-dropdown {
        font-size: 14px;
      }

      .advanceSearch {
        // width: 120px;
        // height: 25px;
        float: left;
        position: relative;
        // top: 10%;
        margin-left: 35px;
        .title {
          height: 75px;
          width: 100%;
          font-size: 16px;
          background-color: rgb(255, 255, 255);
          padding-left: 15%;
          .tag {
            width: 80px;
            height: 45px;
            cursor: pointer;
            text-align: center;
            margin-top: 30px;
          }
          .mark {
            margin-top: 30px;
            margin-right: 18%;
            cursor: pointer;
            i {
              display: inline-block;
              width: 10px;
              height: 10px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
          .active {
            font-weight: bold;
            border-bottom: 3px solid rgb(1, 82, 147);
          }
        }
        span {
          display: inline-block;
          height: 25px;
          position: relative;
          // font-size: 20px;
          color: rgb(1, 82, 147);
          margin-right: 5px;
        }
        // .sign {
        //   top: -30%;
        // }
        .btnAdvance {
          display: inline-block;
          width: 15px;
          height: 15px;
          background-image: url(../../assets/img/advanceSearch.png);
          background-size: 100% 100%;
          padding: 0;
          border: none;
          border-radius: 0;
          cursor: pointer;
          top: 40%;
          position: relative;
          transform: translateY(-50%);
        }
        /deep/ .el-drawer {
          overflow-y: scroll;
        }
        /deep/ .el-drawer__container {
          background: rgba(51, 50, 50, 0.8);
        }

        /deep/ .el-drawer__header {
          padding-top: 10px;
          padding-left: 15%;
          margin-bottom: 0px;
          span {
            font-size: 20px;
            font-weight: bold;
            width: 82px;
            height: 30px;
            border-bottom: 2px solid rgb(1, 82, 147);
            flex: none;
            margin-right: 80%;
          }
        }
        // 修改
        /deep/.el-drawer__body {
          background-color: rgb(247, 247, 247);
        }
      }
      // 高级搜索
      .advanceBody {
        .Title {
          padding-top: 10px;
          font-size: 16px;
          color: rgb(0, 0, 0);
        }
        .searchResult {
          padding: 40px 0 0 15%;
          font-size: 16px;
          .allKey {
            margin-left: 42px;
            margin-bottom: 20px;
            input {
              margin-left: 45px;
              width: 335px;
              height: 40px;
              font-size: 16px;
              border: none;
              background-image: url(../../assets/img/input_bg.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }
          .totalKey {
            margin-left: 115px;
            margin-bottom: 20px;
            input {
              margin-left: 45px;
              width: 335px;
              height: 40px;
              font-size: 16px;
              border: none;
              background-image: url(../../assets/img/input_bg.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }
          .anyKey {
            margin-left: 115px;
            margin-bottom: 20px;
            input {
              margin-left: 30px;
              width: 335px;
              height: 40px;
              font-size: 16px;
              border: none;
              background-image: url(../../assets/img/input_bg.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }
          .noKey {
            margin-left: 113px;
            margin-bottom: 20px;
            input {
              margin-left: 80px !important;
              width: 335px;
              height: 40px;
              font-size: 16px;
              border: none;
              background-image: url(../../assets/img/input_bg.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
            }
          }
        }

        .dateArea {
          padding-left: 15%;
          margin-top: 15px;
        }

        .highDate {
          font-size: 14px;
          span {
            color: black;
          }

          /deep/ .el-dropdown-link {
            cursor: pointer;
            color: black;
          }
          /deep/.el-dropdown {
            font-size: 14px;
          }
        }
        .sortOrder {
          padding-left: 15%;
          margin-top: 15px;
        }
        .searchPosition {
          padding-left: 15%;
          margin-top: 15px;
        }

        .advanceSeachBtn {
          width: 140px;
          height: 40px;
          background-color: rgb(1, 82, 147);
          color: white;
          font-size: 20px;
          outline: none;
          border: none;
          margin-left: 21%;
          margin-top: 20px;
          margin-bottom: 20px;
          border-radius: 5px;
          cursor: pointer;
          appearance: none;
          -moz-appearance: none;
          -webkit-appearance: none;
        }
        .row {
          margin-left: 15%;
          margin-bottom: 20px;
          color: black;
          span {
            color: black;
          }
          input {
            margin-left: 10px;
            height: 25px;
            width: 350px;
          }
        }
        /deep/.el-radio__input.is-checked .el-radio__inner {
          background-color: rgb(1, 82, 147);
          border-color: rgb(1, 82, 147);
        }
        /deep/.el-radio__input.is-checked + .el-radio__label {
          color: rgb(1, 82, 147);
        }
      }
      .isShow {
        height: 25px;
        color: rgb(1, 82, 147);
        .show {
          cursor: pointer;
          i {
            display: inline-block;
            width: 17px;
            height: 17px;
            background-image: url("../../assets/img/show.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            transform: translateY(15%);
          }
        }
        .unShow {
          cursor: pointer;
          i {
            display: inline-block;
            width: 17px;
            height: 17px;
            background-image: url("../../assets/img/unshow.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
            transform: translateY(15%);
          }
        }
      }
    }
    .isAlways {
      i {
        display: inline-block;
        height: 20px;
        width: 20px;
        background-image: url(../../assets/img/isAlways.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        transform: translateY(20%);
      }
    }
    .left {
      float: left;
      width: 845px;
      // width:915px;
      border-right: 1px solid #e5e5e5;
      ul {
        padding: 0;
      }
    }
    .right {
      float: left;
      margin-left: 25px;
      // width: 350px;
      width:330px;
      // border-left: 2px solid rgb(210, 210, 210);
      // padding-left: 20px;
    }
    .hide {
      display: none;
    }
    .bottom_border {
      font-weight: bold;
      border-bottom: 1px solid rgb(1, 82, 147);
      color: rgb(1, 82, 147);
    }
  }
}

// 移动端样式
@media screen and (max-width: 750px) {
  @w: 7.5vw;
  .door {
    display: none;
  }
  .mobile {
    width: 100%;
    display: block;
    .isAlways {
      font-size: 16 / @w;
      margin-bottom: 10 / @w;
      margin-left: 50px / @w;
      font-weight: bold;
    }
    /deep/.el-pagination {
      padding-left: 40 / @w;
      span {
        padding: 0 10 / @w;
      }
    }
  }
}

// 删除ie中input的×号
input::-ms-clear {
  display: none;
}
</style>

<style lang='less'>
// 下拉框颜色
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: rgb(1, 82, 147) !important;
}
// 分页颜色
.el-pager li{
  border: 1px solid #f5f5f5;
  color: #7d7d7d;
  border-radius: 3px;
  margin-right: 3px;
  font-weight: normal;
  line-height: 26px;
}
.el-pager li.active {
  // color: rgb(1, 82, 147);
  background-color: #015293;
  color: #fff;
  border: 1px solid #015293;
}
.el-pager li:hover {
  // color: rgb(1, 82, 147);
  background-color: #015293;
  color: #fff;
  border: 1px solid #015293;
}
/*设置xx条/页的框的颜色*/
.el-select .el-input.is-focus .el-input__inner,
.el-pagination__sizes .el-input .el-input__inner:hover,
.el-select .el-input__inner:focus {
  // border-color: rgb(1, 82, 147);
  background-color: #015293;
}
// 前往第几页的边框的颜色
.el-input__inner:focus {
  border-color: rgb(1, 82, 147) !important;
}
li.el-select-dropdown__item.selected {
  color: rgb(1, 82, 147) !important;
}
.el-date-table td.available:hover {
  color: rgb(1, 82, 147) !important;
}
.el-date-table td.today span {
  color: rgb(1, 82, 147) !important;
}
.el-date-table td.end-date span,
.el-date-table td.start-date span {
  background-color: rgb(1, 82, 147) !important;
}
.el-pagination button:hover {
  color: rgb(1, 82, 147) !important;
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover {
  border-color: rgb(1, 82, 147) !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: rgb(1, 82, 147) !important;
}
.el-pagination.is-background.el-pagination--small .btn-next, .el-pagination.is-background.el-pagination--small .btn-prev, .el-pagination.is-background.el-pagination--small .el-pager li{
  line-height: 19px;
}
.el-select .el-input.is-focus .el-input__inner, .el-pagination__sizes .el-input .el-input__inner:hover, .el-select .el-input__inner:focus{
  background: #fff;
}
</style>